import { matchRoutes } from 'react-router-dom';

import { getRoutes } from '../nav/Routes';
import { PROVIDER_PATH_ID, VISITOR_PATH_ID } from '../nav/config';
import { UserType } from '../types';
import { memoize } from '../utils';

const USER_TYPE_KEY = 'user-type';

function setUserTypeInLocalStorage(userType: UserType): void {
  localStorage.setItem(USER_TYPE_KEY, userType);
}

function getUserTypeFromPath(path: string): UserType | null {
  const [, routes] = getRoutes();
  const matches = matchRoutes(routes, path);

  if (!matches || !matches.length) return null;

  const firstMatchedPathId = matches[0].route.id;

  switch (firstMatchedPathId) {
    case VISITOR_PATH_ID:
      return UserType.CLIENT;
    case PROVIDER_PATH_ID:
      return UserType.PROVIDER;
    default:
      return null;
  }
}

function getUserTypeFromLocalStorage(): UserType | null {
  const userType = localStorage.getItem(USER_TYPE_KEY);
  if (userType === UserType.PROVIDER || userType === UserType.CLIENT) {
    return userType satisfies UserType;
  }
  return null;
}

/**
 * Gets the user type based on the current path and sets it in local storage. If
 * the user type is not found via the path, then the user type that's stored in
 * local storage is returned.
 */
export function getAndSetUserType(path: string): UserType | null {
  const userTypeFromPath = getUserTypeFromPath(path);

  if (userTypeFromPath) {
    setUserTypeInLocalStorage(userTypeFromPath);
    return userTypeFromPath;
  }

  return getUserTypeFromLocalStorage();
}

/**
 * Memoized version of {@link getAndSetUserType}
 */
export const getAndSetUserTypeMemoized = memoize(getAndSetUserType);
